import React, { useState } from "react";
import {
  Box,
  Typography,
  Paper,
  CircularProgress,
  Skeleton,
  TextField,
  InputAdornment,
  FormControl,
  Select,
  MenuItem,
  IconButton,
  Pagination,
} from "@mui/material";
import {
  AutoStories as CourseIcon,
  Search as SearchIcon,
  Clear as ClearIcon,
} from "@mui/icons-material";
import { useGetCourseAdsQuery } from "@/store/api/homepageApi";
import CourseCard from "./CourseCard";

const CourseSection = () => {
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [search, setSearch] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const [sort, setSort] = useState("displayOrder");
  const [order, setOrder] = useState("asc");

  const { data, isLoading, error } = useGetCourseAdsQuery({
    page,
    limit,
    search,
    sort,
    order,
  });

  const courses = data?.data || [];
  const pagination = data?.pagination || {};

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    setSearch(searchInput);
    setPage(1);
  };

  const handleClearSearch = () => {
    setSearchInput("");
    setSearch("");
    setPage(1);
  };

  const handleSortChange = (e) => {
    setSort(e.target.value);
    setPage(1);
  };

  const handlePageChange = (event, value) => {
    setPage(value);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (error) return null;

  return (
    <Paper
      sx={{
        mb: 3,
        backgroundColor: "transparent",
        borderRadius: 4,
        boxShadow: "none",
      }}
    >
      {/* Search and Sort Controls */}
      {/* <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          gap: 2,
          mb: 3,
          alignItems: { xs: "stretch", sm: "center" },
        }}
      > */}
        {/* Search */}
        {/* <Box
          component="form"
          onSubmit={handleSearchSubmit}
          sx={{ flex: 1, minWidth: 0 }}
        >
          <TextField
            fullWidth
            size="small"
            placeholder="Search courses..."
            value={searchInput}
            onChange={(e) => setSearchInput(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ color: "#999" }} />
                </InputAdornment>
              ),
              endAdornment: searchInput && (
                <InputAdornment position="end">
                  <IconButton size="small" onClick={handleClearSearch}>
                    <ClearIcon fontSize="small" />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            sx={{
              backgroundColor: "white",
              borderRadius: 2,
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "rgba(0,0,0,0.1)",
                },
                "&:hover fieldset": {
                  borderColor: "rgba(33,150,243,0.3)",
                },
              },
            }}
          />
        </Box> */}

        {/* Sort */}
        {/* <FormControl
          size="small"
          sx={{
            minWidth: { xs: "100%", sm: 200 },
            backgroundColor: "white",
            borderRadius: 2,
          }}
        >
          <Select
            value={sort}
            onChange={handleSortChange}
            sx={{
              borderRadius: 2,
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "rgba(0,0,0,0.1)",
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "rgba(33,150,243,0.3)",
              },
            }}
          >
            <MenuItem value="displayOrder">Default Order</MenuItem>
            <MenuItem value="title">Title (A-Z)</MenuItem>
            <MenuItem value="price">Price (Low to High)</MenuItem>
            <MenuItem value="createdAt">Newest First</MenuItem>
          </Select>
        </FormControl> */}
      {/* </Box> */}

      {/* Course List */}
      {isLoading ? (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          {[1, 2, 3].map((i) => (
            <Skeleton
              key={i}
              variant="rounded"
              height={160}
              sx={{ borderRadius: 3 }}
            />
          ))}
        </Box>
      ) : courses.length > 0 ? (
        <>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 0 }}>
            {courses.map((course) => (
              <CourseCard key={course._id} course={course} />
            ))}
          </Box>

          {/* Pagination */}
          {pagination.totalPages > 1 && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                mt: 4,
                mb: 2,
              }}
            >
              <Pagination
                count={pagination.totalPages}
                page={page}
                onChange={handlePageChange}
                color="primary"
                size="large"
                showFirstButton
                showLastButton
                sx={{
                  "& .MuiPaginationItem-root": {
                    fontWeight: 600,
                  },
                }}
              />
            </Box>
          )}
        </>
      ) : (
        <Box
          sx={{
            textAlign: "center",
            py: 8,
            backgroundColor: "white",
            borderRadius: 3,
          }}
        >
          <Typography variant="h6" color="text.secondary" gutterBottom>
            No courses found
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {search
              ? `No results for "${search}". Try different keywords.`
              : "No courses available at the moment."}
          </Typography>
        </Box>
      )}
    </Paper>
  );
};

export default CourseSection;
